import { useState, useEffect } from "react";
import "./contact.css";
import Footer from "../../other/footer/footer.jsx";
import { IoLogoInstagram } from "react-icons/io";
import { FaFacebook } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  // Charger reCAPTCHA v3
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://www.google.com/recaptcha/api.js?render=6Le7RyIsAAAAADx4E2NZAuz4mqLIhyav-yBKuiCp";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      // Nettoyer le script si le composant est démonté
      const existingScript = document.querySelector(
        'script[src="https://www.google.com/recaptcha/api.js?render=6Le7RyIsAAAAADx4E2NZAuz4mqLIhyav-yBKuiCp"]'
      );
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // Attendre que reCAPTCHA soit chargé
      if (!window.grecaptcha) {
        throw new Error(
          "reCAPTCHA n'est pas encore chargé. Veuillez réessayer."
        );
      }

      // Obtenir le token reCAPTCHA
      const recaptchaToken = await new Promise((resolve, reject) => {
        window.grecaptcha.ready(() => {
          window.grecaptcha
            .execute("6Le7RyIsAAAAADx4E2NZAuz4mqLIhyav-yBKuiCp", {
              action: "submit",
            })
            .then(resolve)
            .catch(reject);
        });
      });

      // Envoyer les données au serveur
      const response = await fetch("/send-email.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          message: formData.message,
          recaptchaToken: recaptchaToken,
        }),
      });

      const result = await response.json();

      if (response.ok) {
        setSubmitStatus({
          type: "success",
          message: result.message || "Message envoyé avec succès !",
        });
        setFormData({ name: "", email: "", message: "" });
      } else {
        setSubmitStatus({
          type: "error",
          message: result.message || "Erreur lors de l'envoi du message.",
        });
      }
    } catch (error) {
      console.error("Erreur:", error);
      setSubmitStatus({
        type: "error",
        message: "Une erreur est survenue. Veuillez réessayer.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  const infos = [
    {
      info: "+33 (0)4 93 13 81 70",
      link: "tel:+33 04 93 13 81 70",
      ico: "tel",
    },
    // {
    //   info: "+33 (0)4 93 13 81 42",
    //   link: "tel:+33 04 93 13 81 42",
    //   ico: "fix",
    // },
    {
      info: "contact@nice-plomberie.com",
      link: "mailto:contact@nice-plomberie.com",
      ico: "mail",
    },
    {
      info: "7 Impasse des Noisetiers, 06100 Nice",
      link: "https://maps.app.goo.gl/yaS8o5yEqV3qQrgJ7",
      ico: "ping",
    },
  ];

  return (
    <section className="Contact" id="contact">
      <h2>Contact</h2>
      <p>
        Contactez-nous ! Notre équipe service client s'engage à répondre à votre
        demande dans les plus brefs délais.
      </p>
      <div>
        <div className="infos">
          <article>
            <h3>Nos horaires</h3>
            <p>
              <strong>
                Du <span className="underline">lundi</span> au{" "}
                <span className="underline">jeudi</span> :
              </strong>{" "}
              <div className="br-sm" />
              De 8h00 à 12h00 - 13h30 à 17h00
            </p>
            <p>
              <strong>
                Et le <span className="underline">vendredi</span> :
              </strong>{" "}
              <div className="br-sm" />
              De 8h00 à 12h00 - 13h30 à 16h00
            </p>
            <h3>Suivez-nous !</h3>
            <ul className="socials">
              <a
                href="https://www.instagram.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="ico">
                  <IoLogoInstagram />
                </div>
              </a>
              <a
                href="https://www.facebook.com/people/Nice-Plomberie/61564435507872/?_rdr"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="ico">
                  <FaFacebook />
                </div>
              </a>
              <a
                href="https://fr.linkedin.com/company/nice-plomberie?trk=public_post_feed-actor-name"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="ico">
                  <FaLinkedin />
                </div>
              </a>
            </ul>
          </article>
          <article className="info">
            <h3>Nos informations</h3>
            <ul>
              {infos.map(({ info, link, ico }) => {
                return (
                  <a href={link} target="_blank" rel="noopener noreferrer">
                    <div className="ico">{InfoIco(ico)}</div>
                    <p>{info}</p>
                  </a>
                );
              })}
            </ul>
          </article>
        </div>
        <div className="form">
          <h3>On discute ?</h3>
          <form className="contact-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Nom…"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email…"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <textarea
              name="message"
              rows="5"
              placeholder="Votre message…"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
            {submitStatus && (
              <div
                className={`submit-status ${
                  submitStatus.type === "success" ? "success" : "error"
                }`}
              >
                {submitStatus.message}
              </div>
            )}
            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Envoi en cours..." : "Envoyer"}
            </button>
          </form>
        </div>
      </div>

      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2883.4036092293422!2d7.264316499999999!3d43.7229417!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12cdcff7f3d8d3a3%3A0xa50b4dda4436fdf0!2s7%20Imp.%20des%20Noisetiers%2C%2006100%20Nice!5e0!3m2!1sfr!2sfr!4v1764940211539!5m2!1sfr!2sfr"
        width="600"
        height="450"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
        className="map"
      ></iframe>
      <Footer />
    </section>
  );
}

function InfoIco(ico) {
  if (ico === "tel") {
    return (
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.262171 3.98563C0.291454 3.21348 0.621703 2.30661 1.31636 1.55089C1.63848 1.19931 1.97198 0.859233 2.31199 0.527372C2.652 0.197153 2.99364 0.19551 3.32877 0.529015C4.24306 1.43917 5.15083 2.3559 6.05536 3.27755C6.40025 3.62913 6.39537 3.97085 6.0521 4.32407C5.55429 4.83664 5.04509 5.33772 4.54402 5.84866C3.92745 6.47624 3.88352 7.14982 4.40411 7.85626C5.65353 9.54842 7.1307 11.0057 8.83075 12.2329C9.50264 12.7175 10.1908 12.6633 10.7797 12.0686C11.2547 11.5889 11.7217 11.1026 12.1967 10.6212C12.592 10.222 12.9304 10.2154 13.3208 10.6081C14.2026 11.4936 15.0827 12.3824 15.9612 13.2745C16.3582 13.677 16.3598 14.0088 15.9628 14.4064C15.4243 14.9453 14.9135 15.5186 14.2075 15.8571C13.2574 16.3138 12.278 16.4025 11.2678 16.1084C8.57859 15.3231 6.35144 13.7788 4.39923 11.8025C2.91555 10.2992 1.7003 8.60212 0.868983 6.64381C0.541988 5.87494 0.236141 5.09622 0.262171 3.98563Z"
          fill="white"
        />
      </svg>
    );
  } else if (ico === "fix") {
    return (
      <svg
        width="17"
        height="18"
        viewBox="0 0 17 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.2606 17.2778C12.0665 17.2778 7.87356 17.2778 3.67953 17.2778C3.67953 13.6045 3.67953 9.93115 3.67953 6.25781C7.88529 6.25781 12.0676 6.25781 16.2606 6.25781C16.2606 9.93863 16.2606 13.6077 16.2606 17.2778ZM6.34904 11.4069C8.76589 11.4069 11.1753 11.4069 13.59 11.4069C13.59 10.3108 13.59 9.22428 13.59 8.13351C11.1699 8.13351 8.76056 8.13351 6.34904 8.13351C6.34904 9.22963 6.34904 10.3129 6.34904 11.4069ZM11.5079 14.3167C11.1699 14.3167 10.848 14.3167 10.526 14.3167C10.526 14.6493 10.526 14.9679 10.526 15.2888C10.8586 15.2888 11.1806 15.2888 11.5079 15.2888C11.5079 14.9594 11.5079 14.645 11.5079 14.3167ZM7.32666 14.3178C6.9919 14.3178 6.67101 14.3178 6.35224 14.3178C6.35224 14.6503 6.35224 14.9679 6.35224 15.293C6.68167 15.293 6.99936 15.293 7.32666 15.293C7.32666 14.9658 7.32666 14.6482 7.32666 14.3178ZM9.41727 15.2909C9.41727 14.9605 9.41727 14.6418 9.41727 14.3135C9.08678 14.3135 8.76376 14.3135 8.4354 14.3135C8.4354 14.6429 8.4354 14.9626 8.4354 15.2909C8.76589 15.2909 9.08892 15.2909 9.41727 15.2909ZM13.5942 15.2909C13.5942 14.9615 13.5942 14.6429 13.5942 14.3135C13.2638 14.3135 12.9418 14.3135 12.6124 14.3135C12.6124 14.6429 12.6124 14.9615 12.6124 15.2909C12.9418 15.2909 13.2638 15.2909 13.5942 15.2909ZM9.41514 12.4528C9.08039 12.4528 8.75843 12.4528 8.43966 12.4528C8.43966 12.7864 8.43966 13.1051 8.43966 13.428C8.76909 13.428 9.08785 13.428 9.41514 13.428C9.41514 13.1008 9.41514 12.7821 9.41514 12.4528ZM11.5026 13.4291C11.5026 13.0912 11.5026 12.7725 11.5026 12.4517C11.1699 12.4517 10.848 12.4517 10.526 12.4517C10.526 12.7843 10.526 13.1029 10.526 13.4291C10.8554 13.4291 11.1731 13.4291 11.5026 13.4291ZM7.32346 13.4291C7.32346 13.0944 7.32346 12.7725 7.32346 12.4485C6.99297 12.4485 6.67634 12.4485 6.35331 12.4485C6.35331 12.78 6.35331 13.1019 6.35331 13.4291C6.67954 13.4291 6.99297 13.4291 7.32346 13.4291ZM13.5879 13.4259C13.5879 13.0944 13.5879 12.7725 13.5879 12.4474C13.2574 12.4474 12.9397 12.4474 12.6177 12.4474C12.6177 12.78 12.6177 13.1019 12.6177 13.4259C12.9471 13.4259 13.2648 13.4259 13.5879 13.4259Z"
          fill="white"
        />
        <path
          d="M0.260559 17.2776C0.260559 13.2652 0.260559 9.25398 0.260559 5.23096C1.06973 5.23096 1.8629 5.23096 2.6838 5.23096C2.6838 9.24542 2.6838 13.261 2.6838 17.2776C1.8757 17.2776 1.06866 17.2776 0.260559 17.2776Z"
          fill="white"
        />
        <path
          d="M14.9151 4.24739C14.9151 4.5928 14.9151 4.91147 14.9151 5.23977C11.6124 5.23977 8.31919 5.23977 5.01642 5.23977C5.01642 3.58651 5.01642 1.93859 5.01642 0.277832C6.98124 0.277832 8.94819 0.277832 10.9343 0.277832C10.9343 1.59424 10.9343 2.91386 10.9343 4.24739C12.2691 4.24739 13.5836 4.24739 14.9151 4.24739Z"
          fill="white"
        />
        <path
          d="M14.5324 3.24718C13.7083 3.24718 12.8331 3.24718 11.9471 3.24718C11.9471 2.36708 11.9471 1.49018 11.9471 0.658203C12.7989 1.51157 13.6742 2.3874 14.5324 3.24718Z"
          fill="white"
        />
        <path
          d="M12.6007 9.12988C12.6007 9.56405 12.6007 9.9779 12.6007 10.4057C10.8469 10.4057 9.09852 10.4057 7.34479 10.4057C7.34479 9.97684 7.34479 9.55871 7.34479 9.12988C9.09745 9.12988 10.8416 9.12988 12.6007 9.12988Z"
          fill="white"
        />
      </svg>
    );
  } else if (ico === "mail") {
    return (
      <svg
        width="19"
        height="13"
        viewBox="0 0 19 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.260559 1.57973C0.310324 1.43523 0.360088 1.28972 0.405618 1.15625C2.22468 2.86523 4.03315 4.56317 5.84374 6.26413C4.02574 7.9701 2.21726 9.66804 0.401383 11.373C0.364324 11.2696 0.312441 11.1231 0.260559 10.9766C0.260559 7.84466 0.260559 4.71169 0.260559 1.57973Z"
          fill="white"
        />
        <path
          d="M18.2606 10.9764C18.2108 11.1209 18.161 11.2654 18.1144 11.3999C16.2954 9.69091 14.488 7.99297 12.6774 6.29201C14.4986 4.58303 16.3102 2.88409 18.124 1.18213C18.161 1.2895 18.2108 1.43501 18.2606 1.57952C18.2606 4.71148 18.2606 7.84445 18.2606 10.9764Z"
          fill="white"
        />
        <path
          d="M1.16692 0.40029C1.38715 0.356136 1.56715 0.315995 1.74821 0.284886C1.81597 0.272844 1.88797 0.279869 1.95892 0.279869C6.82739 0.279869 11.6948 0.279869 16.5633 0.278865C16.8237 0.278865 17.0747 0.307967 17.3288 0.421364C17.279 0.472543 17.242 0.512684 17.2017 0.550817C14.7209 2.91007 12.239 5.26933 9.75715 7.62859C9.43209 7.93767 9.08798 7.93767 8.76292 7.62758C6.28209 5.26933 3.80021 2.91007 1.31939 0.549814C1.28233 0.515694 1.24739 0.478564 1.16692 0.40029Z"
          fill="white"
        />
        <path
          d="M11.8949 7.0284C13.7066 8.72935 15.5119 10.4233 17.3532 12.1523C17.1382 12.1975 16.9614 12.2376 16.7814 12.2697C16.7136 12.2818 16.6416 12.2748 16.5707 12.2748C11.698 12.2748 6.82527 12.2748 1.9515 12.2758C1.69315 12.2758 1.44115 12.2517 1.19127 12.1303C3.00821 10.4253 4.8135 8.73036 6.63045 7.02539C6.64527 7.03844 6.69186 7.07657 6.73633 7.11872C7.16621 7.52715 7.59609 7.93658 8.02597 8.34601C8.75445 9.03743 9.7635 9.03643 10.4941 8.34702C10.9674 7.90045 11.4417 7.4559 11.8949 7.0284Z"
          fill="white"
        />
      </svg>
    );
  } else if (ico === "ping") {
    return (
      <svg
        width="14"
        height="18"
        viewBox="0 0 14 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.77321 17.4661C6.05325 16.7497 5.37264 16.109 4.73268 15.4299C3.40957 14.0266 2.21597 12.5206 1.32078 10.7924C0.773504 9.73451 0.360825 8.63293 0.27575 7.42479C0.0789343 4.62077 1.78933 1.9169 4.39999 0.912896C8.25758 -0.572565 12.4148 1.78979 13.1615 5.89439C13.4142 7.281 13.164 8.60212 12.6231 9.88087C11.8168 11.7887 10.6067 13.4257 9.23023 14.9381C8.45567 15.7906 7.6265 16.5931 6.77321 17.4661ZM6.76432 9.67288C8.20044 9.67032 9.36737 8.49042 9.36864 7.03706C9.36991 5.58498 8.20298 4.39994 6.76813 4.39609C5.32185 4.39224 4.14604 5.58241 4.15112 7.04604C4.15493 8.49684 5.32693 9.67545 6.76432 9.67288Z"
          fill="white"
        />
      </svg>
    );
  }
}
